module.exports = __webpack_public_path__ + "img/uparrow.8d086fd3.svg";